import React from 'react';
import { COPY } from '../contracts/copyMap';
import PublicPageLayout from '../components/public/PublicPageLayout';

// Public contact page — one inbox for account, data, and Glowup requests.
const Contact = () => (
  <PublicPageLayout
    title={COPY.PAGE_TITLE_CONTACT}
    eyebrow={COPY.CONTACT_EYEBROW}
    headline={COPY.CONTACT_HEADLINE}
  >
    <p className="m-0 font-display text-[17px] leading-relaxed text-bone">
      {COPY.CONTACT_BODY}
    </p>
    <a
      href={`mailto:${COPY.CONTACT_EMAIL}`}
      className="mt-8 inline-block border border-aurum px-6 py-3 font-display uppercase text-[13px] tracking-[0.2em] text-aurum no-underline transition-colors hover:bg-aurum hover:text-obsidian"
    >
      {COPY.CONTACT_EMAIL}
    </a>
    <p className="mt-8 m-0 font-display text-[14px] leading-relaxed text-bone-dim">
      {COPY.CONTACT_NOTE}
    </p>
  </PublicPageLayout>
);

export default Contact;
